import { useQuery } from '@tanstack/react-query';
import { getUpsellOffer } from '../api/upsellOffer/getUpsellOffer';
import { UpsellOfferOrigin, OfferType, UpsellOfferResponse } from '../@types/upsellOffer';

interface UpsellOfferState {
  initializing: boolean;
  isError?: boolean;
  upsellOffer: UpsellOfferResponse | undefined;
}

export const useGetUpsellOffer = (
  origin: UpsellOfferOrigin,
  type: OfferType,
  enabled: boolean = true,
): UpsellOfferState => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['upsell-offer', origin, type],
    queryFn: () => getUpsellOffer(origin, type),
    enabled,
  });

  return {
    initializing: isLoading || isFetching || isError,
    isError,
    upsellOffer: data,
  };
};
